import { cn } from '../lib/cn'
import { Badge } from '../primitives/Badge'
import { Toggle } from '../primitives/Toggle'

export interface SkillItem {
  id: string
  command: string
  name: string
  description: string
  enabled: boolean
  source?: 'local' | 'server'
}

export interface SkillsViewProps {
  skills: SkillItem[]
  onToggle: (id: string, enabled: boolean) => void
}

export function SkillsView({ skills, onToggle }: SkillsViewProps) {
  return (
    <div className="flex-1 space-y-3 overflow-y-auto px-4 py-4">
      <p className="text-sm text-neutral-500">
        Als <span className="font-medium text-brand-600">/befehl</span> im Chat verfügbar.
      </p>
      {skills.map((skill) => (
        <div
          key={skill.id}
          className={cn(
            'flex items-center justify-between gap-3 rounded-xl border border-neutral-200 p-3.5',
            !skill.enabled && 'opacity-60',
          )}
        >
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <span className="font-semibold text-brand-700">{skill.command}</span>
              {skill.source === 'server' && <Badge tone="neutral">Server</Badge>}
            </div>
            <p className="mt-0.5 text-sm text-neutral-500">{skill.description}</p>
          </div>
          <Toggle
            checked={skill.enabled}
            onChange={(v) => onToggle(skill.id, v)}
            label={skill.command}
          />
        </div>
      ))}
    </div>
  )
}
